import { useEffect } from "react";
import styled from "styled-components";

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Text = styled.div`
  color: #dc3545;
  word-break: keep-all;
`;

const ErrorMsg = styled.span`
  color: #dc3545;
`;

const CustomText = ({
  title,
  code,
  options,
  openModal,
  register,
  formState,
  reset,
  getValues,
  watch,
  detailData,
}) => {
  return (
    <>
      <Div>
        {options?.map((option, i) => (
          <Text key={i}>{option.oname}</Text>
        ))}
        <ErrorMsg>{formState?.errors[code]?.message}</ErrorMsg>
      </Div>
    </>
  );
};
export default CustomText;
